import { gql } from '@apollo/client';

export const WAREHOUSE_PLANNING_ENTRY_CONFIG_FIELDS = gql`
    fragment WarehousePlanningEntryConfigFields on WarehousePlanningEntryConfigType {
        id
        warehouseId
        warehouseName
        entryNode
        entryNodeDescription
        pushMode
        isActive
        splitOrderConfig
        templateEditStartTime
        templateEditEndTime
        createdAt
        createdBy
        updatedAt
        updatedBy
    }
`;

export interface WarehousePlanningEntryConfigType {
    id: string;
    warehouseId: number;
    warehouseName?: string;
    entryNode: string;
    entryNodeDescription: string;
    /** 推送模式：0-自动 1-手动（分批次-尾程） */
    pushMode?: number;
    isActive: boolean;
    splitOrderConfig: number[];
    templateEditStartTime?: string;
    templateEditEndTime?: string;
    createdAt?: string;
    createdBy?: string;
    updatedAt?: string;
    updatedBy?: string;
}

export interface EntryNodeOptionType {
    value: string;
    description: string;
}

